import { Component, OnInit, inject } from "@angular/core";
import { ExportBase } from "@app/export/exporttypes/export-base";
import { LocalizationService } from "@app/shared";
import { FormGroup, FormControl, ReactiveFormsModule } from "@angular/forms";
import { FormValidators } from "@app/shared/helpers/form-validators";
import { FormValidationMessageHelper } from "@app/shared/helpers/form-validation-message-helper";
import { FormValidationHelper } from "@app/shared/helpers/form-validation-helper";
import { ToastrService } from "ngx-toastr";
import { getFormValue } from "@methods/CommonMethods";
import { provideTranslocoScope, TranslocoPipe, TranslocoService } from "@jsverse/transloco";
import { DateInputComponent } from "@app/shared/components/date-input/date-input.component";

interface KriDataPointsExportModel {
    startDate: Date;
    endDate: Date;
}

@Component({
    selector: "export-kri",
    templateUrl: "./kris-data-points-export.component.html",
    styleUrls: ["./kris-data-points-export.component.scss"],
    providers: [provideTranslocoScope("export")],
    imports: [ReactiveFormsModule, TranslocoPipe, DateInputComponent]
})
export class KrisDataPointsExportComponent extends ExportBase implements OnInit {
    private localizationService = inject(LocalizationService);
    private toastr = inject(ToastrService);
    private transloco = inject(TranslocoService);

    public mainFormGroup: FormGroup;
    get startDate(): Date {
        return getFormValue<KriDataPointsExportModel>(this.mainFormGroup, "startDate");
    }
    get endDate(): Date {
        return getFormValue<KriDataPointsExportModel>(this.mainFormGroup, "endDate");
    }

    ngOnInit(): void {
        this.initFormValidation();
    }

    public exportKriDataPoints() {
        if (this.mainFormGroup.invalid) {
            FormValidationHelper.markAllAsTouched(this.mainFormGroup);

            const validationMessage = new FormValidationMessageHelper<KriDataPointsExportModel>({
                startDate: this.transloco.translate("export.kri.startDate"),
                endDate: this.transloco.translate("export.kri.endDate"),
            })
                .processFormGroup(this.mainFormGroup)
                .getErrorMessage();

            this.toastr.warning(validationMessage, this.transloco.translate("export.kri.exportFailedToast"), { enableHtml: true });

            return;
        }

        const startDate = this.localizationService.formatInvariantDate(this.startDate);
        const endDate = this.localizationService.formatInvariantDate(this.endDate);

        const extra = `startdate=${startDate}&enddate=${endDate}`;
        this.exportDataService.downloadExport(this.ExportType.KrisDataPoints, extra);
    }

    initFormValidation() {
        this.mainFormGroup = new FormGroup(
            {
                startDate: new FormControl(null),
                endDate: new FormControl(null),
            },
            {
                validators: [
                    FormValidators.startEndDate<KriDataPointsExportModel>("startDate", "endDate"),
                    FormValidators.allEmptyOrAllFilled<KriDataPointsExportModel>(
                        "startDate",
                        "endDate"
                    ),
                ],
            }
        );
    }
}
